import { Injectable } from '@angular/core';
import { TodayTripInformation } from '@com-delta-idp/mnx-capability-flyout-ui';
import {
  checkBooleanValueNull,
  checkStringValueNull,
  DashboardResponse,
  HeaderFooterMachCore
} from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { TodaysTrip } from '../../models/interfaces/todays-trip/todays-trip.interface';
import { getMemberDescriptionMessage } from '../../utils/account-summary-header/flyout-account-summary-header.utils';

@Injectable({
  providedIn: 'root'
})
export class FlyoutTodayTripInfoAdapterService {
  getTodayTripsInformation(
    todayTrip: TodaysTrip,
    userSession: DashboardResponse,
    content: HeaderFooterMachCore
  ): TodayTripInformation {
    const trip = todayTrip?.trip;
    return {
      flightStatus: this.getFlightStatusInfo(trip?.flightStatus),
      membershipLevel: getMemberDescriptionMessage(userSession, content),
      ...this.getTripDetails(trip),
      ...this.getUserDetails(userSession)
    };
  }

  private getTripDetails(trip: TodaysTrip['trip']) {
    return {
      recordLocator: checkStringValueNull(trip?.recordLocator),
      iropMessage: checkStringValueNull(trip?.iropMessage),
      mktCarrierCode: checkStringValueNull(trip?.mktCarrierCode),
      mktFlightNumber: checkStringValueNull(trip?.mktFlightNumber),
      optCarrierCode: checkStringValueNull(trip?.optCarrierCode),
      departureCityCode: checkStringValueNull(trip?.departureCityCode),
      arrivalCityCode: checkStringValueNull(trip?.arrivalCityCode),
      checkInLink: checkStringValueNull(trip?.checkinLink),
      seatNumber: checkStringValueNull(trip?.seatNumber),
      actualFlightDepartureTime: checkStringValueNull(
        trip?.actFlightDepartureTime
      ),
      scheduleFlightDepartureTime: checkStringValueNull(
        trip?.schedFlightDepartureTime
      ),
      actualFlightArrivalTime: checkStringValueNull(trip?.actFlightArrivalTime),
      scheduleFlightArrivalTime: checkStringValueNull(
        trip?.schedFlightArrivalTime
      ),
      viewTripDetails: checkStringValueNull(trip?.viewTripDetails),
      findOtherFlights: checkStringValueNull(trip?.findOtherFlights),
      remainOnFlight: checkBooleanValueNull(trip?.remainOnFlight),
      checkedIn: checkBooleanValueNull(trip?.checkedIn),
      checkInEligible: checkBooleanValueNull(trip?.checkinEligible)
    };
  }

  private getUserDetails(userSession: DashboardResponse) {
    return {
      firstName: checkStringValueNull(userSession?.firstName),
      middleName: checkStringValueNull(userSession?.middleName),
      lastName: checkStringValueNull(userSession?.lastName),
      skyPriority: checkBooleanValueNull(userSession?.skyPriority)
    };
  }

  private getFlightStatusInfo(
    flightStatus?: TodaysTrip['trip']['flightStatus']
  ) {
    return {
      status: this.capitalizeFirstLetter(
        checkStringValueNull(flightStatus?.status)
      ),
      gate: checkStringValueNull(flightStatus?.gate),
      terminal: checkStringValueNull(flightStatus?.terminal),
      statusColor: checkStringValueNull(flightStatus?.statusColor)
    };
  }

  private capitalizeFirstLetter(str: string): string {
    if (!str) return str;
    return str
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
}
